/* eslint-disable import/prefer-default-export */
export const zoomSMBPlans = [
  {
    type: 'SMB',
    title: 'Pro',
    seats: '1 - 9 Seats',
    description: 'Include Zoom Meetings, Whiteboard, Team Chat, Mail, and Calendar',
    features: [
      '100 Meeting Participants',
      'AI Companion',
      'Team Chat',
      'Productivity: Clips, Notes, Surveys',
      'Mail and Calendar',
      '3 Whiteboards + 25GB Storage',
      '5GB Cloud Storage',
      'Automated Captions',
      'Integrations with Microsoft, Google, Salesforce, Servicenow, and more',
    ],
    ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  },
  {
    type: 'SMB',
    title: 'Business',
    seats: '10+ Seats',
    description: 'Adds more capacity and users',
    features: [
      '<span class="text-[#295BF6] font-medium">300</span> Meeting Participants',
      '<span class="text-[#295BF6] font-medium">Unlimited</span> Whiteboards',
      'Scheduler',
      'Single Sign-On Security',
      'Managed Domains',
      'Branding',
    ],
    additionalContent:
      '<div class="bg-[#295BF61A] p-2.5 flex items-center justify-center gap-[7px] rounded-[10px]"><p class="text-[10px]">Also Include everything in</p><div class="text-xs text-white text-center px-2.5 py-[2px] rounded-[10px] bg-[#3066D2]">Zoom Pro</div></div>',
    ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  },
  // {
  //   type: 'SMB',
  //   title: 'Business+',
  //   seats: '10+ Seats',
  //   description: 'Adds Zoom Phone, Workspace Reservation, Translation, and Cloud Storage',
  //   features: [
  //     'Phone*',
  //     'Workspace Reservation / Visitor Mgmt',
  //     'Translation',
  //     '<span class="text-[#295BF6] font-medium">100GB</span> Cloud Storage',
  //   ],
  //   additionalContent:
  //     '<div class="bg-[#295BF61A] p-2.5 flex items-center justify-center gap-[7px] rounded-[10px]"><p class="text-[10px]">Also Include everything in</p><div class="text-xs text-white text-center px-2.5 py-[2px] rounded-[10px] bg-[#3066D2]">Business</div></div>',
  //   ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  // },
];
